import { render, staticRenderFns } from "./FormSummarySidebar.vue?vue&type=template&id=1a87708a&scoped=true"
import script from "./FormSummarySidebar.vue?vue&type=script&lang=js"
export * from "./FormSummarySidebar.vue?vue&type=script&lang=js"
import style0 from "./FormSummarySidebar.vue?vue&type=style&index=0&id=1a87708a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a87708a",
  null
  
)

export default component.exports